/**
 * Created by Administrador on 26/10/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('generalManifest', {
                parent: 'app',
                url: '/generalManifest',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/manifest/generalManifest/generalManifest.html',
                        controller: 'generalManifestCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabManifestos('generalManifest')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['generalManifest']);
                            }],
                            airports:['airportService',function(airportService){
                                return airportService.getAirportsActiveDisable(true);
                            }]
                        }
                    }
                }
            });
    }
})();
